import { useNullableCallToken } from "../lib/callToken";

// eslint-disable-next-line import/prefer-default-export
export function useCallToken() {
  const tokenResult = useNullableCallToken();
  if (!tokenResult.callToken) {
    throw new Error("Missing call token");
  }
  return tokenResult;
}
